import React from 'react';
import { Heart, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer py-12 md:py-16">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* BOT Bakery Logo */}
          <div className="flex justify-center mb-12">
            <div className="footer-logo-wrapper">
              <img 
                src="https://customer-assets.emergentagent.com/job_bot-bakery-landing/artifacts/idb45joq_BOT%20Artwork%20%281%29.jpg"
                alt="BOT Bakery Logo - Organic Vegan Gluten-Free"
                className="footer-logo-image"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div>
              <h3 className="text-2xl font-bold mb-4">BOT Bakery</h3>
              <p className="opacity-80 leading-relaxed">
                Chicago's first all-vegan, all gluten-free bakery. Handcrafting delicious treats since 2007.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#products" className="footer-link">
                    Products & Services
                  </a>
                </li>
                <li>
                  <a href="#events" className="footer-link">
                    Events & Markets
                  </a>
                </li>
                <li>
                  <a href="#gallery" className="footer-link">
                    Gallery
                  </a>
                </li>
                <li>
                  <a href="https://www.bettybotshop.com" target="_blank" rel="noopener noreferrer" className="footer-link">
                    bettybotshop.com
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Follow Us</h4>
              <div className="space-y-3">
                <a 
                  href="https://www.instagram.com/bettybotbakery"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 footer-social-link"
                >
                  <Instagram className="h-5 w-5" />
                  <span>@bettybotbakery</span>
                </a>
                <a 
                  href="https://instagram.com/chicagoveganbakers"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 footer-social-link"
                >
                  <Instagram className="h-5 w-5" />
                  <span>@chicagoveganbakers</span>
                </a>
                <a 
                  href="https://instagram.com/chicagoveganfarmersmarket"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 footer-social-link"
                >
                  <Instagram className="h-5 w-5" />
                  <span>@chicagoveganfarmersmarket</span>
                </a>
              </div>
            </div>
          </div>

          <div className="footer-divider mb-8"></div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="footer-copyright">
              © {currentYear} BOT Bakery. All rights reserved.
            </p>
            <p className="flex items-center gap-2 footer-made-with">
              Made with <Heart className="h-4 w-4 footer-heart" fill="currentColor" /> in Chicago
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
